import { pause, resume } from '@noriginmedia/norigin-spatial-navigation';
import { isInViewport } from 'common/utils/helpers';
import { useCallback, useRef } from 'react';

function useDisableFocusOutOfView() {
  const uiCheckerFrameId = useRef<number | null>(null);

  const recursiveCheck = useCallback(
    (node: HTMLElement, container?: HTMLElement, offsetX?: number, offsetY?: number) => {
      const uiChecker = () => {
        // If the node is in the viewport, or it has been removed from the DOM, resume navigation.
        // Otherwise, pause it and check again on the next animation frame.
        if (isInViewport(node, offsetX, offsetY, container) || !document.body.contains(node)) {
          resume();
        } else {
          pause();
          uiCheckerFrameId.current = requestAnimationFrame(uiChecker);
        }
      };
      uiCheckerFrameId.current && cancelAnimationFrame(uiCheckerFrameId.current);
      uiChecker();
    },
    []
  );

  const stopChecking = useCallback(() => {
    uiCheckerFrameId.current && cancelAnimationFrame(uiCheckerFrameId.current);
  }, []);

  return { recursiveCheck, stopChecking };
}

export default useDisableFocusOutOfView;
